export const status = {
  draft: 'Szkic',
  archived: 'Zarchiwizowany',
  published: 'Opublikowany',
} as const
